(function () {
  'use strict';

  var hdr = document.querySelector('[data-mz-header]');
  if (!hdr) return;

  var desk = window.matchMedia('(min-width: 1280px)');
  var delay = parseInt(hdr.getAttribute('data-delay'), 10) || 0;
  var panelsWrap = hdr.querySelector('[data-mz-panels]');
  var scrim = hdr.querySelector('[data-mz-scrim]');
  var full = hdr.querySelector('.mz-hdr__full');
  var tabs = Array.prototype.slice.call(hdr.querySelectorAll('[data-mz-open]'));
  var current = null;
  var openTimer = null;
  var closeTimer = null;

  function panelFor(i) { return document.getElementById('mz-panel-' + i); }

  // fit the panel between the header and the bottom of the screen
  function fit() {
    if (!current) return;
    var top = panelsWrap.getBoundingClientRect().top;
    var room = Math.floor(window.innerHeight - top - 1);
    var p = panelFor(current);
    var h = parseInt(getComputedStyle(hdr).getPropertyValue('--mz-panel-h'), 10) || 680;
    hdr.style.setProperty('--mz-room', room + 'px');
    hdr.classList.toggle('is-tall', room < h && !!p);
  }

  function open(i) {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    if (current === i) return;
    if (current) panelFor(current).hidden = true;
    current = i;
    panelFor(i).hidden = false;
    tabs.forEach(function (t) { t.setAttribute('aria-expanded', t.getAttribute('data-mz-open') === i ? 'true' : 'false'); });
    hdr.classList.add('is-open');
    scrim.hidden = false;
    fit();
  }

  function close() {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    if (!current) return;
    panelFor(current).hidden = true;
    current = null;
    tabs.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    hdr.classList.remove('is-open', 'is-tall');
    scrim.hidden = true;
  }

  tabs.forEach(function (tab) {
    var i = tab.getAttribute('data-mz-open');
    tab.addEventListener('mouseenter', function () {
      if (!desk.matches) return;
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      openTimer = setTimeout(function () { open(i); }, delay);
    });
    // passing over a tab on the way down to the panel shouldn't switch it
    tab.addEventListener('mouseleave', function () { clearTimeout(openTimer); });
    tab.addEventListener('click', function () {
      if (current === i) close(); else open(i);
    });
    tab.addEventListener('keydown', function (e) {
      var row = Array.prototype.slice.call(tab.parentNode.querySelectorAll('.mz-tab'));
      var at = row.indexOf(tab);
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        var next = row[(at + (e.key === 'ArrowRight' ? 1 : row.length - 1)) % row.length];
        next.focus();
        if (current && next.hasAttribute('data-mz-open')) open(next.getAttribute('data-mz-open'));
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        open(i);
        var first = panelFor(i).querySelector('a, button');
        if (first) first.focus();
      }
    });
  });

  // leaving the tabs and panel together closes it, with a little grace
  [full, hdr.querySelector('[data-mz-compact]'), panelsWrap].forEach(function (zone) {
    if (!zone) return;
    zone.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    zone.addEventListener('mouseleave', function () {
      if (!desk.matches) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(close, 250);
    });
  });
  scrim.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (current) {
      var back = hdr.querySelector('.mz-tab[data-mz-open="' + current + '"]:not([hidden])');
      close();
      if (back && back.offsetParent) back.focus();
    }
    closeAcct();
    if (drawer && !drawer.hidden) closeDrawer();
  });
  panelsWrap.addEventListener('focusout', function (e) {
    if (e.relatedTarget && !hdr.contains(e.relatedTarget)) close();
  });
  window.addEventListener('resize', function () {
    if (!desk.matches) close(); else fit();
  });

  // compact bar once the full header has scrolled away
  if (hdr.getAttribute('data-compact') === 'true' && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var away = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      if (away !== hdr.classList.contains('is-compact')) {
        close();
        hdr.classList.toggle('is-compact', away);
      }
    }).observe(full);
  }

  // account menu in the compact bar
  var acct = hdr.querySelector('[data-mz-acct]');
  var acctBtn = acct && acct.querySelector('button');
  var acctMenu = acct && acct.querySelector('.mz-acct__menu');
  var acctTimer = null;
  function openAcct() { clearTimeout(acctTimer); close(); acctMenu.hidden = false; acctBtn.setAttribute('aria-expanded', 'true'); }
  function closeAcct() { if (!acct) return; acctMenu.hidden = true; acctBtn.setAttribute('aria-expanded', 'false'); }
  if (acct) {
    acct.addEventListener('mouseenter', function () { if (desk.matches) openAcct(); });
    acct.addEventListener('mouseleave', function () { acctTimer = setTimeout(closeAcct, 200); });
    acctBtn.addEventListener('click', function () { if (acctMenu.hidden) openAcct(); else closeAcct(); });
    acct.addEventListener('focusout', function (e) { if (!acct.contains(e.relatedTarget)) closeAcct(); });
  }

  // phone drawer
  var drawer = hdr.querySelector('[data-mz-drawer]');
  var root = drawer.querySelector('[data-mz-droot]');
  var body = drawer.querySelector('.mz-drawer__body');
  var opener = hdr.querySelector('[data-mz-drawer-open]');

  function showRoot() {
    Array.prototype.forEach.call(drawer.querySelectorAll('.mz-dpanel'), function (p) { p.hidden = true; });
    root.hidden = false;
    body.scrollTop = 0;
  }
  function openDrawer() {
    showRoot();
    drawer.hidden = false;
    opener.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('mz-locked');
    drawer.querySelector('[data-mz-drawer-close]').focus();
  }
  function closeDrawer() {
    if (drawer.hidden || drawer.classList.contains('is-closing')) return;
    opener.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('mz-locked');
    // slide out, then hide; the timer covers reduced motion where no animation runs
    var done = function (e) {
      if (e && e.target !== drawer) return;
      drawer.removeEventListener('animationend', done);
      clearTimeout(timer);
      drawer.classList.remove('is-closing');
      drawer.hidden = true;
      opener.focus();
    };
    var timer = setTimeout(done, 320);
    drawer.addEventListener('animationend', done);
    drawer.classList.add('is-closing');
  }
  opener.addEventListener('click', openDrawer);
  drawer.querySelector('[data-mz-drawer-close]').addEventListener('click', closeDrawer);
  drawer.addEventListener('click', function (e) {
    var go = e.target.closest('[data-mz-dopen]');
    if (go) {
      var p = document.getElementById(go.getAttribute('data-mz-dopen'));
      root.hidden = true;
      p.hidden = false;
      body.scrollTop = 0;
      p.querySelector('[data-mz-back]').focus();
      return;
    }
    if (e.target.closest('[data-mz-back]')) {
      var from = e.target.closest('.mz-dpanel').id;
      showRoot();
      var btn = drawer.querySelector('[data-mz-dopen="' + from + '"]');
      if (btn) btn.focus();
    }
  });
  desk.addEventListener('change', function () { if (desk.matches && !drawer.hidden) closeDrawer(); });

  // search bar; the suggestions panel lives in mz-search.js
  var search = hdr.querySelector('#nn-popup-search');
  if (search) {
    var hideSearch = function () { if (window.bootstrap) bootstrap.Collapse.getOrCreateInstance(search).hide(); };
    search.addEventListener('shown.bs.collapse', function () {
      close();
      var input = search.querySelector('input');
      if (input) input.focus();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && search.classList.contains('show')) hideSearch();
    });
    document.addEventListener('click', function (e) {
      if (search.classList.contains('show') && !hdr.contains(e.target)) hideSearch();
    });
  }

  // GA4: one event per menu click, through GTM's dataLayer
  var eventName = hdr.getAttribute('data-event');
  if (eventName) {
    hdr.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a || a.closest('[data-mz-sp]')) return;
      var tabEl = a.closest('[data-mz-tab]');
      var colEl = a.closest('[data-mz-col]');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        menu_tab: tabEl ? tabEl.getAttribute('data-mz-tab') : (a.classList.contains('mz-tab') ? a.textContent.trim() : 'Header'),
        menu_column: colEl ? colEl.getAttribute('data-mz-col') : '',
        menu_item: (a.getAttribute('aria-label') || a.textContent).trim().replace(/\s+/g, ' '),
        menu_url: a.getAttribute('href'),
        menu_layout: desk.matches ? (hdr.classList.contains('is-compact') ? 'compact' : 'full') : 'drawer'
      });
    });
  }

  // theme editor: show the panel for the block being edited
  document.addEventListener('shopify:block:select', function (e) {
    var p = e.target && e.target.closest && e.target.closest('.mz-panel');
    if (p && desk.matches) open(p.id.replace('mz-panel-', ''));
  });
  document.addEventListener('shopify:block:deselect', close);
})();
